import * as types from '../mutation-types'
import {unionState} from '../union-state'

const state = {
	materials_tree: [],
	warehouse_materials: [],
	materials: [],
};
const actions = {
	fetchTree({ commit },  warehouseId ) {
		return window.axios.get(`Warehouses/${warehouseId}/MaterialsTree`
		).then(response => {
			commit(types.STORE_MATERIALS_TREE, response.data);
			return response.data;
		});
	},

	fetchAll({ commit }) {
		return window.axios.get('Warehouses/Materials'
		).then(response => {
			commit(types.STORE_MATERIALS, response.data);
			return response.data;
		});
	},
	fetch({ commit }, { warehouseId, materialId }) {
		return window.axios.get(`Warehouses/${warehouseId}/Materials/${materialId}`
		).then(response => {
			commit(types.STORE_ONE_MATERIAL, response.data);
			return response.data;
		});
	},

	/* eslint-disable no-unused-vars */
	fetchLastPurchasePrice({ commit }, materialId ) {
		return window.axios.get(`MaterialFlow/Invoices/${materialId}/LastPurchasePrice`
		).then(response => {
			return response.data;
		});
	},
	/* eslint-enable no-unused-vars */

	fetchWarehouseMaterials({ commit }, warehouseId ) {
		return window.axios.get(`Warehouses/${warehouseId}/Materials`).then(response => {
			commit(types.STORE_WAREHOUSE_MATERIALS, response.data);
			return response.data;
		});
	},

	create({ commit }, { warehouseId, material, materialItems }) {
		return window.axios.post(`Warehouses/${warehouseId}/Materials`, {
            name: material.name,
            inner_no: material.inner_no,
            type: material.type,
            category: material.category,
            purchase_price: material.purchase_price,
            sale_price: material.sale_price,
            notes: material.notes,
            parent_id: material.parent_id,
            purchases_account_id: material.purchases_account_id,
            purchases_refund_account_id: material.purchases_refund_account_id,
            sales_account_id: material.sales_account_id,
            sales_refund_account_id: material.sales_refund_account_id,
            manufacturer: material.manufacturer,
            min_quantity: material.min_quantity,
            max_quantity: material.max_quantity,
            specifications: material.specifications,
			unit_size_id: material.unit_size_id,
			barcode: material.barcode,
			english_name: material.english_name,
			manufacturer_code: material.manufacturer_code,
			country_of_origin: material.country_of_origin,
			is_required_serial_num: material.is_required_serial_num,
			materials_duplication: materialItems
		}).then(response => {
			commit(types.STORE_ONE_MATERIAL, response.data)
			return response.data;
		});
	},

	update({ commit }, { warehouseId, material, editStatus, destinationMateriallEdit }) {
		return window.axios.put(`Warehouses/${warehouseId}/Materials/${material.id}`, {
			id: material.id,
            name: material.name,
            inner_no: material.inner_no,
            type: material.type,
            category: material.category,
            purchase_price: material.purchase_price,
            sale_price: material.sale_price,
            notes: material.notes,
            parent_no: material.parent_id, // Patch #8017 bug
            purchases_account_id: material.purchases_account_id,
            purchases_refund_account_id: material.purchases_refund_account_id,
            sales_account_id: material.sales_account_id,
            sales_refund_account_id: material.sales_refund_account_id,
            manufacturer: material.manufacturer,
            min_quantity: material.min_quantity,
            max_quantity: material.max_quantity,
            specifications: material.specifications,
			unit_size_id: material.unit_size_id,
			barcode: material.barcode,
			is_required_serial_num: material.is_required_serial_num,
			english_name: material.english_name,
			manufacturer_code: material.manufacturer_code,
			country_of_origin: material.country_of_origin,
			edit_status: editStatus,
			destination_materiall_edit: destinationMateriallEdit,
		}).then( response => {
			commit(types.STORE_ONE_MATERIAL, response.data);
			return response.data;
		});
	},

	updateCopyMaterials(_, { warehouseId, materialId, warehousesMaterials }) {
		return window.axios.post(`Warehouses/${warehouseId}/${materialId}/CopyMaterials`, warehousesMaterials
		)
	},

	updateinventoryPrice({ commit }, { warehouse_id, material_id, invevtory_price }) {
		return window.axios.put(`Warehouses/${warehouse_id}/Materials/${material_id}/InventoryPrice`, { 
			invevtory_price
		}).then( response => {
			commit('', '');
			return response.data;
		});
	},
	delete({ commit }, { warehouseId, materialId }) {
		return window.axios.delete(`Warehouses/${warehouseId}/Materials/${materialId}`).then(() => {
			commit(types.DELETE_MATERIAL, materialId)
		});
	},
	
	GenerateNewInnerNo({commit}, {warehouseId, materialId}){
		return window.axios.get(`Warehouses/${warehouseId}/Materials/${materialId}/GenerateNewNo`).then(response => {
			commit('', '')
			return response.data;
		});
	},
	getNodeMaterials(_, { nodeId, warehouseId}) {
		return window.axios.get(`warehouses/${warehouseId}/${nodeId}/Descendants`).then( ({ data }) => data)
	},
	getWarehouseMaterialsTree(_, id) {
		return window.axios.get(`Warehouses/${id}/MaterialsTree`).then( ({ data }) => data);
	},
	copyWarehouseMaterials(_,{id, materials, linked_with_another}) {
		return window.axios.post(`Warehouses/${id}/CopyMaterials`, {
			material_ids: materials,
			linked_with_another: linked_with_another
		}).then( ({ data }) => data);
	},
	getMaterialSerialNumbers(_, {materialId, invoiceType}) {

		return window.axios.get(`/MaterialFlow/MaterialsJournals/SerialNumber/${materialId}/invoiceType/${invoiceType}`).then(({data}) => data);
	},
	checkSerialNumber(_, {materialId, serialNumber}) {
		return window.axios.get(`/MaterialFlow/MaterialsJournals/SerialNumber/${materialId}/${serialNumber}`).then(({data}) => data);
	}
};

const mutations = {
	[types.STORE_MATERIALS_TREE](state, materials_tree) {
		state.materials_tree = materials_tree;
	},
    
	[types.STORE_MATERIALS](state, materials) {
		state.materials = materials;
	},

    [types.STORE_WAREHOUSE_MATERIALS](state, warehouse_materials) {
		state.warehouse_materials = warehouse_materials;
	},

	[types.STORE_ONE_MATERIAL](state, material) {
		state.warehouse_materials = unionState(state.warehouse_materials, [material]);
	},

	[types.DELETE_MATERIAL](state, material) {
		state.warehouse_materials = unionState(state.warehouse_materials, [material]);
	},
};

const getters = {
	getById: state => id => state.warehouse_materials.find(t => t.id === id),
	getMaterialById: state => id => state.materials.find(c => c.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

